import { create } from 'zustand'

const useCountryStore = create(
        set => ({
            selectedCountry: '',
            setSelectedCountry: selectedCountry => set(state => ({
                ...state,
                selectedCountry
            })),
        }),
)

export default useCountryStore